import {
    ChevronRightMedium,
    ExternalLinkMedium
} from '@zoopla-eng/zds-components/icons';

import { MojoLogo } from '@zoopla/assets';

import {
    mojoImageStyle,
    notificationActionIconStyle,
    notificationContentStyle,
    notificationDescriptionStyle,
    notificationLinkStyle,
    notificationTitleStyle
} from './Notification.styles.css';

import {
    NotificationResult,
    NotificationTypeValues
} from '../../../graphql.generated';
import { NotificationIcon } from '../NotificationIcon/NotificationIcon';

import { EventNames, trackSegmentAndGAEvent, Taxonomy } from '@zoopla/tracking';

type NotificationProps = Omit<NotificationResult, 'createdAt' | 'icon'> & {
    noBorder?: boolean;
};

export const Notification = ({
    title,
    description,
    type,
    link,
    noBorder
}: NotificationProps) => {
    const clickNotificationTaxonomy: Taxonomy = {
        page: '/myaccount/my-home/',
        path: '/myaccount/my-home/notifications/',
        brand: 'zoopla',
        activity: 'my_home_notifications',
        section: 'my-home'
    };

    const openInNewTab =
        type === NotificationTypeValues.PlanningApplication ||
        type === NotificationTypeValues.GetMortgage;

    const clickNotificationTracking = () => {
        trackSegmentAndGAEvent(
            EventNames.CLICK_NOTIFICATION,
            {
                eventCategory: 'my home notifications',
                eventAction: 'click',
                eventLabel: type
            },
            `/myaccount/my-home/notifications`,
            clickNotificationTaxonomy
        );
    };
    return (
        <a
            className={notificationLinkStyle({ noBorder })}
            href={link}
            onClick={clickNotificationTracking}
            data-testid="notification"
            target={openInNewTab ? '_blank' : ''}
            rel="noreferrer"
        >
            <div className={notificationContentStyle}>
                <NotificationIcon notificationType={type} />
                <div>
                    <p className={notificationTitleStyle}>{title}</p>
                    <p className={notificationDescriptionStyle}>
                        {description}
                    </p>
                    {type === NotificationTypeValues.GetMortgage && (
                        <MojoLogo className={mojoImageStyle} />
                    )}
                </div>
            </div>
            <div className={notificationActionIconStyle}>
                {openInNewTab ? (
                    <div data-testid="external-link-icon">
                        <ExternalLinkMedium />
                    </div>
                ) : (
                    <div data-testid="chevron-icon">
                        <ChevronRightMedium />
                    </div>
                )}
            </div>
        </a>
    );
};
